import React, {useContext} from 'react';
import {useFormContext, useWatch} from 'react-hook-form';
import {UserContext} from '../../../../src/contexts/UserContext';
import {IOrderStatusModel} from '../../../../src/@interfaces/models/Order/IOrderStatusModel';
import {IOrderModel} from '../../../../src/@interfaces/models/Order/IOrderModel';
import {StatusCommentField} from '../products/extra_row/StatusCommentField';
import FormField, {Props} from '../../../../src/components/Form/FormField';

const emptyArray: never[] = [];

export function OrderStatusWithCommentField<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    const userContext = useContext(UserContext);
    const {control, formState: {dirtyFields}} = useFormContext();
    const activeStatusId = useWatch({control, name: props.fieldName});
    const options = props.modelOptions?.status ?? emptyArray;
    const activeStatus = options?.find(({value}) => value === activeStatusId);
    const statusRequiresReason = (activeStatus as any as IOrderStatusModel)?.is_comment_required === true;

    if (!control || !userContext) {
        return <FormField {...props}/>;
    }

    const canLeaveReason = userContext.can('orders@can-leave-order-status-changing-reason');
    const isDirty = dirtyFields[props.fieldName] === true;
    const shouldDisplayReasonForm = statusRequiresReason && canLeaveReason && isDirty;

    return <>
        <FormField {...props}/>

        {shouldDisplayReasonForm ? (
                <div className="mb-3" style={{marginTop: '-0.5rem'}}>
                    <StatusCommentField
                            control={control}
                            containerPath="status_changing_reason"
                            isDisabled={props.forceDisabled}
                            isReadonly={props.forceReadonly}
                    />
                </div>
        ) : null}
    </>;
}
